import React from "react";
import { Form, Typography } from "antd";
import { getFormItemLabel } from "../../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
const { Text } = Typography;

const YesNoItem = (props) => {
  const { name, category } = props;

  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);

  const ContentComponent = ({ value }) => {
    return (
      <Text ellipsis style={{ whiteSpace: "normal" }}>
        {value
          ? intl.formatMessage({
              id: "app.dataSelect.yes",
            })
          : intl.formatMessage({
              id: "app.dataSelect.no",
            })}
      </Text>
    );
  };

  return (
    <div>
      <Form.Item name={name} label={label}>
        <ContentComponent />
      </Form.Item>
    </div>
  );
};

YesNoItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
};

export default YesNoItem;
